let Config = {
  developmentMode: false,
  skipLoginValidation: false,
  serverBaseUrl: 'https://localhost:3005/',
  clientBaseUrl: 'http://localhost:8080/',
  nodeDefaultBrandsUrl: '../../../../node/framework/v1/brand-default/',
  nodeCobrandBrandsUrl: '../../../../node/brands/',
  nodeUrl: 'http://localhost:3000/',
  finappIframeUrl: 'http://localhost:3000/finapp/'
  //nodeUrl: 'http://192.168.112.93:5000/',
  //finappIframeUrl: 'http://192.168.112.93:5000/finapp/'
}
export default Config